import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function NewsletterSection() {
  return <section className="py-24 relative overflow-hidden" style={{
    background: '#0d0d0d'
  }} data-id="element-172">
      <div className="absolute inset-0 bg-cage-grid opacity-5 pointer-events-none" data-id="element-173" />
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 50%, rgba(245,230,20,0.03) 0%, transparent 60%)'
    }} data-id="element-174" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-175">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} className="text-6xl md:text-8xl font-bebas mb-4" style={{
        color: '#e0e0e0'
      }} data-id="element-176">
          GET FIRST ACCESS
        </motion.h2>

        <p className="font-barlow text-xl tracking-widest uppercase mb-10" style={{
        color: '#555'
      }} data-id="element-177">
          Pre-fight drops. Exclusive collabs. No spam. Just fire.
        </p>

        <form className="flex flex-col md:flex-row gap-4 max-w-xl mx-auto mb-12" data-id="element-178">
          <input type="email" placeholder="ENTER YOUR EMAIL" className="flex-1 px-6 py-4 font-barlow text-lg focus:outline-none transition-all duration-300" style={{
          background: 'rgba(255,255,255,0.03)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.07)',
          color: '#e0e0e0'
        }} onFocus={e => {
          e.currentTarget.style.borderColor = 'rgba(245,230,20,0.3)';
          e.currentTarget.style.boxShadow = '0 0 20px rgba(245,230,20,0.06)';
        }} onBlur={e => {
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)';
          e.currentTarget.style.boxShadow = 'none';
        }} data-id="element-179" />
          <button type="submit" className="px-8 py-4 font-bebas text-xl tracking-wider flex items-center justify-center gap-2 transition-all duration-300" style={{
          background: 'rgba(153,27,27,0.8)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(153,27,27,0.35)',
          color: '#e0e0e0',
          boxShadow: '0 0 20px rgba(153,27,27,0.12)'
        }} onMouseEnter={e => {
          ;
          (e.currentTarget as HTMLButtonElement).style.background = 'rgba(127,29,29,0.9)';
          (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 0 30px rgba(153,27,27,0.2)';
        }} onMouseLeave={e => {
          ;
          (e.currentTarget as HTMLButtonElement).style.background = 'rgba(153,27,27,0.8)';
          (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 0 20px rgba(153,27,27,0.12)';
        }} data-id="element-180">
            JOIN THE FIGHT <ArrowRight className="w-5 h-5" data-id="element-181" />
          </button>
        </form>

        <div className="flex items-center justify-center gap-3 font-barlow text-sm tracking-wider uppercase" style={{
        color: '#555'
      }} data-id="element-182">
          <span className="w-2 h-2 rounded-full" style={{
          background: 'rgba(245,230,20,0.6)',
          boxShadow: '0 0 8px rgba(245,230,20,0.4)'
        }} data-id="element-183" />
          12,000+ FIGHTERS ALREADY IN
        </div>
      </div>
    </section>;
}